
export class Labor {
  id: string
  name: string
  description: string
  hourlyRate: number
  hours: number
  total: number

  constructor () {
    this.name = ''
    this.description = ''
    this.hourlyRate = 0.00
  }
}
